export default {
  shared: {
    id: {
      id: 'pages.patientViewer.table.columnHeaders.shared.id',
      defaultMessage: 'ID',
    },
    favorite: {
      id: 'pages.patientViewer.table.columnHeaders.shared.favorite',
      defaultMessage: 'Favorite',
    },
    status: {
      id: 'pages.patientViewer.table.columnHeaders.shared.status',
      defaultMessage: 'Status',
    },
    category: {
      id: 'pages.patientViewer.table.columnHeaders.shared.category',
      defaultMessage: 'Category',
    },
    type: {
      id: 'pages.patientViewer.table.columnHeaders.shared.type',
      defaultMessage: 'Type',
    },
    time: {
      id: 'pages.patientViewer.table.columnHeaders.shared.time',
      defaultMessage: 'Time',
    },
    issued: {
      id: 'pages.patientViewer.table.columnHeaders.shared.issued',
      defaultMessage: 'Issued',
    },
    value: {
      id: 'pages.patientViewer.table.columnHeaders.shared.value',
      defaultMessage: 'Value',
    },
    dataAbsentReason: {
      id: 'pages.patientViewer.table.columnHeaders.shared.dataAbsentReason',
      defaultMessage: 'Data Absent Reason',
    },
    interpretation: {
      id: 'pages.patientViewer.table.columnHeaders.shared.interpretation',
      defaultMessage: 'Interpretation',
    },
    comment: {
      id: 'pages.patientViewer.table.columnHeaders.shared.comment',
      defaultMessage: 'Comment',
    },
    bodySite: {
      id: 'pages.patientViewer.table.columnHeaders.shared.bodySite',
      defaultMessage: 'Body Site',
    },
    method: {
      id: 'pages.patientViewer.table.columnHeaders.shared.method',
      defaultMessage: 'Method',
    },
    reason: {
      id: 'pages.patientViewer.table.columnHeaders.shared.reason',
      defaultMessage: 'Reason',
    },
    outcome: {
      id: 'pages.patientViewer.table.columnHeaders.shared.outcome',
      defaultMessage: 'Outcome',
    },
    complication: {
      id: 'pages.patientViewer.table.columnHeaders.shared.complication',
      defaultMessage: 'Complication',
    },
    followUp: {
      id: 'pages.patientViewer.table.columnHeaders.shared.followUp',
      defaultMessage: 'Follow Up',
    },
    note: {
      id: 'pages.patientViewer.table.columnHeaders.shared.note',
      defaultMessage: 'Note',
    },
    severity: {
      id: 'pages.patientViewer.table.columnHeaders.shared.severity',
      defaultMessage: 'Severity',
    },
    code: {
      id: 'pages.patientViewer.table.columnHeaders.shared.code',
      defaultMessage: 'Code',
    },
    priority: {
      id: 'pages.patientViewer.table.columnHeaders.encounter.priority',
      defaultMessage: 'Priority',
    },
    medication: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.medication',
      defaultMessage: 'Medication',
    },
    dosageText: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dosageText',
      defaultMessage: 'Dosage Instructions',
    },
    dosageAdditionalInstruction: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dosageAdditionalInstruction',
      defaultMessage: 'Additional Instructions',
    },
    dosagePatientInstruction: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dosagePatientInstruction',
      defaultMessage: 'Patient Instructions',
    },
    dosageTiming: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dosageTiming',
      defaultMessage: 'Dosage Timing',
    },
    dosageAsNeeded: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dosageAsNeeded',
      defaultMessage: 'As Needed?',
    },
    dosageSite: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dosageSite',
      defaultMessage: 'Administer Site',
    },
    dosageRoute: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dosageRoute',
      defaultMessage: 'Administer Route',
    },
    dosageMethod: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dosageMethod',
      defaultMessage: 'Administer Method',
    },
    dosageDose: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dosageDose',
      defaultMessage: 'Dose',
    },
    dosageRate: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dosageRate',
      defaultMessage: 'Dosage Rate',
    },
    link: {
      id: 'pages.patientViewer.table.columnHeaders.shared.link',
      defaultMessage: 'Link',
    },
  },
  procedure: {
    notDone: {
      id: 'pages.patientViewer.table.columnHeaders.procedure.notDone',
      defaultMessage: 'Not Completed?',
    },
    notDoneReason: {
      id: 'pages.patientViewer.table.columnHeaders.procedure.notDoneReason',
      defaultMessage: 'Not Completed Reason',
    },
    usedCode: {
      id: 'pages.patientViewer.table.columnHeaders.procedure.usedCode',
      defaultMessage: 'Used Items',
    },
  },
  encounter: {
    class: {
      id: 'pages.patientViewer.table.columnHeaders.encounter.class',
      defaultMessage: 'Class',
    },
    length: {
      id: 'pages.patientViewer.table.columnHeaders.encounter.length',
      defaultMessage: 'Length',
    },
    reason: {
      id: 'pages.patientViewer.table.columnHeaders.encounter.reason',
      defaultMessage: 'Reason',
    },
    hospitalizationAdmitSource: {
      id: 'pages.patientViewer.table.columnHeaders.encounter.hospitalizationAdmitSource',
      defaultMessage: 'Hospitalization Admit Source',
    },
    hospitalizationReAdmission: {
      id: 'pages.patientViewer.table.columnHeaders.encounter.hospitalizationReAdmission',
      defaultMessage: 'Hospitalization Re-Admit Type',
    },
    hospitalizationDietPreferences: {
      id: 'pages.patientViewer.table.columnHeaders.encounter.hospitalizationDietPreferences',
      defaultMessage: 'Hospitalization Diet Preferences',
    },
    hospitalizationSpecialCourtesy: {
      id: 'pages.patientViewer.table.columnHeaders.encounter.hospitalizationSpecial Courtesy',
      defaultMessage: 'Hospitalization Special Courtesy',
    },
    hospitalizationSpecialArrangement: {
      id: 'pages.patientViewer.table.columnHeaders.encounter.hospitalizationSpecialArrangement',
      defaultMessage: 'Hospitalization Special Arrangement',
    },
  },
  condition: {
    clinicalStatus: {
      id: 'pages.patientViewer.table.columnHeaders.condition.clinicalStatus',
      defaultMessage: 'Clinical Status',
    },
    verificationStatus: {
      id: 'pages.patientViewer.table.columnHeaders.condition.verificationStatus',
      defaultMessage: 'Verification Status',
    },
    onset: {
      id: 'pages.patientViewer.table.columnHeaders.condition.onset',
      defaultMessage: 'Onset',
    },
    abatement: {
      id: 'pages.patientViewer.table.columnHeaders.condition.abatement',
      defaultMessage: 'Abatement',
    },
    asserted: {
      id: 'pages.patientViewer.table.columnHeaders.condition.asserted',
      defaultMessage: 'Asserted Date',
    },
  },
  medicationRequest: {
    groupIdentifier: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.groupIdentifier',
      defaultMessage: 'Medication Order ID',
    },
    intent: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.intent',
      defaultMessage: 'Intent',
    },
    authoredOn: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.authoredOn',
      defaultMessage: 'Authored On',
    },
    dispenceValidityPeriod: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dispenseValidityPeriod',
      defaultMessage: 'Valid Dispense Period',
    },
    dispenseNumberOfRepeatsAllowed: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dispenseNumberOfRepeatsAllowed',
      defaultMessage: 'Allow Dispense Repeats',
    },
    dispenseQuanity: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dispenseQuantity',
      defaultMessage: 'Dispense Quantity',
    },
    dispenseSupplyDuration: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.dispenseSupplyDuration',
      defaultMessage: 'Dispense Supply Duration',
    },
    subsitutionAllowed: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.subsitutionAllowed',
      defaultMessage: 'Substitution Allowed?',
    },
    substitutionReason: {
      id: 'pages.patientViewer.table.columnHeaders.medicationRequest.subsitutionReason',
      defaultMessage: 'Substitution Reason',
    },
  },
  medicationAdministration: {
    notGiven: {
      id: 'pages.patientViewer.table.columnHeaders.medicationAdministration.notGiven',
      defaultMessage: 'Not Given?',
    },
    reasonNotGiven: {
      id: 'pages.patientViewer.table.columnHeaders.medicationAdministration.reasonNotGiven',
      defaultMessage: 'Reason Not Given',
    },
    reasonCode: {
      id: 'pages.patientViewer.table.columnHeaders.medicationAdministration.reasonCode',
      defaultMessage: 'Reason Adminstered',
    },
    note: {
      id: 'pages.patientViewer.table.columnHeaders.medicationAdministration.note',
      defaultMessage: 'Note',
    },
  },
  medicationStatement: {
    dateAsserted: {
      id: 'pages.patientViewer.table.columnHeaders.medicationStatement.dateAsserted',
      defaultMessage: 'Date Asserted',
    },
    taken: {
      id: 'pages.patientViewer.table.columnHeaders.medicationStatement.taken',
      defaultMessage: 'Taken?',
    },
    reasonNotTaken: {
      id: 'pages.patientViewer.table.columnHeaders.medicationStatement.reasonNotTaken',
      defaultMessage: 'Reason Not Take',
    },
    reasonTaken: {
      id: 'pages.patientViewer.table.columnHeaders.medicationStatement.reasonTaken',
      defaultMessage: 'Reason Taken',
    },
  },
  media: {
    type: {
      id: 'pages.patientViewer.table.columnHeaders.media.type',
      defaultMessage: 'Type',
    },
    subType: {
      id: 'pages.patientViewer.table.columnHeaders.media.subType',
      defaultMessage: 'Subtype',
    },
    view: {
      id: 'pages.patientViewer.table.columnHeaders.media.view',
      defaultMessage: 'View',
    },
    time: {
      id: 'pages.patientViewer.table.columnHeaders.media.time',
      defaultMessage: 'Time',
    },
    reason: {
      id: 'pages.patientViewer.table.columnHeaders.media.reason',
      defaultMessage: 'Reason',
    },
    bodySite: {
      id: 'pages.patientViewer.table.columnHeaders.media.bodySite',
      defaultMessage: 'Body Site',
    },
    height: {
      id: 'pages.patientViewer.table.columnHeaders.media.height',
      defaultMessage: 'Height (px)',
    },
    width: {
      id: 'pages.patientViewer.table.columnHeaders.media.width',
      defaultMessage: 'Width (px)',
    },
    frames: {
      id: 'pages.patientViewer.table.columnHeaders.media.frames',
      defaultMessage: 'Frames',
    },
    duration: {
      id: 'pages.patientViewer.table.columnHeaders.media.duration',
      defaultMessage: 'Duration (s)',
    },
    note: {
      id: 'pages.patientViewer.table.columnHeaders.media.note',
      defaultMessage: 'Note',
    },
    contentType: {
      id: 'pages.patientViewer.table.columnHeaders.media.contentType',
      defaultMessage: 'Content Type',
    },
    title: {
      id: 'pages.patientViewer.table.columnHeaders.media.title',
      defaultMessage: 'Title',
    },
  },
  documentReference: {
    masterIdentifier: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.masterIdentifier',
      defaultMessage: 'Master ID',
    },
    status: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.status',
      defaultMessage: 'Status',
    },
    docStatus: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.compositionStatus',
      defaultMessage: 'Composition Status',
    },
    type: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.type',
      defaultMessage: 'Type',
    },
    class: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.class',
      defaultMessage: 'Class',
    },
    createTime: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.created',
      defaultMessage: 'Created Time',
    },
    time: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.time',
      defaultMessage: 'Time',
    },
    description: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.description',
      defaultMessage: 'Description',
    },
    securityLabel: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.securityLabel',
      defaultMessage: 'Security Label',
    },
    link: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.link',
      defaultMessage: 'Link',
    },
    format: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.format',
      defaultMessage: 'Format',
    },
    event: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.event',
      defaultMessage: 'Documented Act',
    },
    period: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.period',
      defaultMessage: 'Documented Service Period',
    },
    facilityType: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.facilityType',
      defaultMessage: 'Documentation Facility',
    },
    practiceSetting: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.practiceSetting',
      defaultMessage: 'Documentation Practice Setting',
    },
    contentType: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.contentType',
      defaultMessage: 'Content Type',
    },
    title: {
      id: 'pages.patientViewer.table.columnHeaders.documentReference.title',
      defaultMessage: 'Title',
    },
  },
  diagnosticReport: {
    status: {
      id: 'pages.patientViewer.table.columnHeaders.diagnosticReport.status',
      defaultMessage: 'Status',
    },
    category: {
      id: 'pages.patientViewer.table.columnHeaders.diagnosticReport.category',
      defaultMessage: 'Category',
    },
    code: {
      id: 'pages.patientViewer.table.columnHeaders.diagnosticReport.code',
      defaultMessage: 'Code',
    },
    codedDiagnosis: {
      id: 'pages.patientViewer.table.columnHeaders.diagnosticReport.codedDiagnosis',
      defaultMessage: 'Coded Diagnosis',
    },
    conclusion: {
      id: 'pages.patientViewer.table.columnHeaders.diagnosticReport.conclusion',
      defaultMessage: 'Conclusion',
    },
    title: {
      id: 'pages.patientViewer.table.columnHeaders.diagnosticReport.title',
      defaultMessage: 'Title',
    },
    issued: {
      id: 'pages.patientViewer.table.columnHeaders.diagnosticReport.issued',
      defaultMessage: 'Issued',
    },
  },
  medicationDispense: {
    status: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.status',
      defaultMessage: 'Status',
    },
    medication: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.medication',
      defaultMessage: 'Medication',
    },
    type: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.type',
      defaultMessage: 'Type',
    },
    quantity: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.quantity',
      defaultMessage: 'Quantity',
    },
    daysSupply: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.daysSupply',
      defaultMessage: 'Days Supply',
    },
    whenPrepared: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.whenPrepared',
      defaultMessage: 'When Prepared',
    },
    whenHandedOver: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.whenHandedOver',
      defaultMessage: 'When Handed Over',
    },
    note: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.note',
      defaultMessage: 'Note',
    },
    dosageInstruction: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.dosageInstruction',
      defaultMessage: 'Dosage Instruction',
    },
    wasSubstituted: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.wasSubstituted',
      defaultMessage: 'Was Substituted?',
    },
    substitutionType: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.substitutionType',
      defaultMessage: 'Substitution Type',
    },
    substitutionReason: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.substitutionReason',
      defaultMessage: 'Substitution Reason',
    },
    notDone: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.notDone',
      defaultMessage: 'Not Done',
    },
    notDoneReason: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.notDoneReason',
      defaultMessage: 'Not Done Reason',
    },
  },
  referralRequest: {
    groupIdentifier: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.groupIdentifier',
      defaultMessage: 'Group Identifier',
    },
    status: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.status',
      defaultMessage: 'Status',
    },
    intent: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.intent',
      defaultMessage: 'Intent',
    },
    type: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.type',
      defaultMessage: 'Type',
    },
    priority: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.priority',
      defaultMessage: 'Priority',
    },
    serviceRequested: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.serviceRequested',
      defaultMessage: 'Actions Requested',
    },
    whenServiceRequested: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.whenServiceRequested',
      defaultMessage: 'When Service Requested',
    },
    authoredOn: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.authoredOn',
      defaultMessage: 'Authored On',
    },
    specialty: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.specialty',
      defaultMessage: 'Specialty',
    },
    reason: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.reason',
      defaultMessage: 'Reason',
    },
    description: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.description',
      defaultMessage: 'Description',
    },
    note: {
      id: 'pages.patientViewer.table.columnHeaders.medicationDispense.note',
      defaultMessage: 'Note',
    },
  },
  specimen: {
    accessionIdentifier: {
      id: 'pages.patientViewer.table.columnHeaders.specimen.accessionIdentifier',
      defaultMessage: 'Lab Identifier',
    },
    type: {
      id: 'pages.patientViewer.table.columnHeaders.specimen.type',
      defaultMessage: 'Type',
    },
    status: {
      id: 'pages.patientViewer.table.columnHeaders.specimen.status',
      defaultMessage: 'Status',
    },
    receivedTime: {
      id: 'pages.patientViewer.table.columnHeaders.specimen.recievedTime',
      defaultMessage: 'Received Date',
    },
    collection: {
      id: 'pages.patientViewer.table.columnHeaders.specimen.collection',
      defaultMessage: 'Collection Date',
    },
    collectionQuantity: {
      id: 'pages.patientViewer.table.columnHeaders.specimen.collectionQuantity',
      defaultMessage: 'Collection Quantity',
    },
    collectionMethod: {
      id: 'pages.patientViewer.table.columnHeaders.specimen.collectionMethod',
      defaultMessage: 'Collection Method',
    },
    collectionBodySite: {
      id: 'pages.patientViewer.table.columnHeaders.specimen.collectionBodySite',
      defaultMessage: 'Collection Body Site',
    },
    description: {
      id: 'pages.patientViewer.table.columnHeaders.specimen.description',
      defaultMessage: 'Description',
    },
    procedure: {
      id: 'pages.patientViewer.table.columnHeaders.specimen.procedure',
      defaultMessage: 'Procedure',
    },
    note: {
      id: 'pages.patientViewer.table.columnHeaders.specimen.note',
      defaultMessage: 'Note',
    },
  },
  imagingStudy: {
    status: {
      id: 'pages.patientViewer.table.columnHeaders.imagingStudy.status',
      defaultMessage: 'Status',
    },
    modality: {
      id: 'pages.patientViewer.table.columnHeaders.imagingStudy.modality',
      defaultMessage: 'Modality',
    },
    started: {
      id: 'pages.patientViewer.table.columnHeaders.imagingStudy.started',
      defaultMessage: 'Study Start Date',
    },
    procedure: {
      id: 'pages.patientViewer.table.columnHeaders.imagingStudy.procedure',
      defaultMessage: 'Procedure',
    },
    reason: {
      id: 'pages.patientViewer.table.columnHeaders.imagingStudy.reason',
      defaultMessage: 'Study Reason',
    },
    note: {
      id: 'pages.patientViewer.table.columnHeaders.imagingStudy.note',
      defaultMessage: 'Notes',
    },
    description: {
      id: 'pages.patientViewer.table.columnHeaders.imagingStudy.description',
      defaultMessage: 'Description',
    },
  },
  consent: {
    status: {
      id: 'pages.patientViewer.table.columnHeaders.consent.status',
      defaultMessage: 'Status',
    },
    date: {
      id: 'pages.patientViewer.table.columnHeaders.consent.date',
      defaultMessage: 'Date',
    },
    sourceReference: {
      id: 'pages.patientViewer.table.columnHeaders.consent.sourceReference',
      defaultMessage: 'Source',
    },
  },
  immunization: {
    date: {
      id: 'pages.patientViewer.table.columnHeaders.immunization.date',
      defaultMessage: 'Date',
    },
    manufacturer: {
      id: 'pages.patientViewer.table.columnHeaders.immunization.manufacturer',
      defaultMessage: 'Manufacturer',
    },
  },
  procedureRequest: {
    code: {
      id: 'pages.patientViewer.table.columnHeaders.procedureRequest.code',
      defaultMessage: 'Request',
    },
    authoredOn: {
      id: 'pages.patientViewer.table.columnHeaders.procedureRequest.authoredOn',
      defaultMessage: 'Authored Date',
    },
    occurrence: {
      id: 'pages.patientViewer.table.columnHeaders.procedureRequest.occurrence',
      defaultMessage: 'Occurrence Date',
    },
    intent: {
      id: 'pages.patientViewer.table.columnHeaders.procedureRequest.intent',
      defaultMessage: 'Intent',
    },
    priority: {
      id: 'pages.patientViewer.table.columnHeaders.procedureRequest.priority',
      defaultMessage: 'Priority',
    },
    status: {
      id: 'pages.patientViewer.table.columnHeaders.procedureRequest.status',
      defaultMessage: 'Status',
    },
  },
  coverage: {
    code: {
      id: 'pages.patientViewer.table.columnHeaders.coverage.type',
      defaultMessage: 'Type',
    },
    period: {
      id: 'pages.patientViewer.table.columnHeaders.coverage.period',
      defaultMessage: 'Period',
    },
    status: {
      id: 'pages.patientViewer.table.columnHeaders.coverage.status',
      defaultMessage: 'Status',
    },
  },
  explanationOfBenefit: {
    type: {
      id: 'pages.patientViewer.table.columnHeaders.explanationOfBenefit.type',
      defaultMessage: 'Type',
    },
    billablePeriod: {
      id: 'pages.patientViewer.table.columnHeaders.exlanationOfBenefit.period',
      defaultMessage: 'Billable Period',
    },
    status: {
      id: 'pages.patientViewer.table.columnHeaders.explanationOfBenefit.status',
      defaultMessage: 'Status',
    },
    outcome: {
      id: 'pages.patientViewer.table.columnHeaders.explanationOfBenefit.status',
      defaultMessage: 'Outcome',
    },
    totalCost: {
      id: 'pages.patientViewer.table.columnHeaders.explanationOfBenefit.totalCost',
      defaultMessage: 'Total Cost',
    },
    payment: {
      id: 'pages.patientViewer.table.columnHeaders.explanationOfBenefit.payment',
      defaultMessage: 'Payment',
    },
  },
};
